var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "post-tile" },
    [
      _vm.content.image && _vm.content.link
        ? _c(
            "nuxt-link",
            {
              staticClass: "post-tile__image-tile",
              attrs: { to: "/" + _vm.content.link }
            },
            [
              _c("img", {
                staticClass: "post-tile__image",
                attrs: { src: _vm.content.image, alt: "" }
              }),
              _c("div", {
                staticClass: "post-tile__cover",
                style: { "background-image": "url(" + _vm.content.image + ")" }
              })
            ]
          )
        : _vm._e(),
      _vm.content.link
        ? _c(
            "nuxt-link",
            {
              staticClass: "post-tile__name",
              attrs: { to: "/" + _vm.content.link }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.content.title) + "\n\t")]
          )
        : _vm._e(),
      _vm.content.meta
        ? _c("post-meta", { attrs: { content: _vm.content.meta } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0911f0c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0911f0c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PostTile.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0911f0c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PostTile.vue
// module chunks = 0